import React, { useState } from "react";
import { AppBar, Modal, Fade, Box, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { menuItems } from "./menuItems";
import ZHP from "../assets/images/ZHP_ID.svg";
import NavLinkItem from "./NavLinkItem";
import { useMsal } from "@azure/msal-react";
import LoginNavItem from "./LoginNavItem";
import { useNavigate } from "react-router-dom";

export default function MobileNav() {
  const [open, setOpen] = useState(false);
  const { accounts } = useMsal();
  const navigate = useNavigate();

  const toggleDrawer = (state) => () => {
    setOpen(state);
  };

  return (
    <>
      <AppBar
        position="static"
        elevation={0}
        sx={{ backgroundColor: "transparent", px: 5, pt: 2 }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          height={64}
        >
          <img
            src={ZHP}
            alt="Identyfikator Związku Harcerstwa Polskiego"
            style={{ height: 54, cursor: "pointer" }}
            onClick={() => {
              navigate("/");
              toggleDrawer(false);
            }}
          />

          <IconButton
            onClick={toggleDrawer(true)}
            aria-label="menu"
            sx={{
              backgroundColor: "#afca0b",
              borderRadius: 2,
              width: 40,
              height: 40,
              "&:hover": {
                backgroundColor: "#afca0b",
              },
            }}
          >
            <MenuIcon sx={{ color: "white" }} />
          </IconButton>
        </Box>
      </AppBar>

      <Modal open={open} onClose={toggleDrawer(false)}>
        <Fade in={open} timeout={300}>
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              bgcolor: "white",
              zIndex: 1300,
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              px: 5,
              pt: 3,
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <img
                src={ZHP}
                alt="Identyfikator Związku Harcerstwa Polskiego"
                style={{ height: 54, cursor: "pointer" }}
                onClick={() => {
                  navigate("/");
                  toggleDrawer(false);
                }}
              />
              <IconButton
                onClick={toggleDrawer(false)}
                sx={{
                  backgroundColor: "none",
                  width: 40,
                  height: 40,
                  borderRadius: 2,
                  "&:hover": {
                    backgroundColor: "none",
                  },
                }}
              >
                <CloseIcon sx={{ color: "#afca0b" }} />
              </IconButton>
            </Box>
            <Box
              component="nav"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 3,
                mt: 6,
              }}
            >
              {menuItems.map((item) => (
                <NavLinkItem
                  key={item.to}
                  label={item.label}
                  to={item.to}
                  onClick={toggleDrawer(false)}
                />
              ))}
              {accounts.length > 0 && (
                <NavLinkItem
                  label="Lista zgłoszeń"
                  to="/lista"
                  onClick={toggleDrawer(false)}
                />
              )}
              <LoginNavItem onClickClose={toggleDrawer(false)} />
            </Box>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}
